export const resolveWebsocketUrl = (path: string): string => {
   const { protocol, host } = window.location;
   const wsProtocol = protocol === 'http:' ? 'ws:' : 'wss:';
   return `${wsProtocol}//${host}${path}`;
};
